export default "__VITE_ASSET__7a007392__"